
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"matrix(2,0,0,2,0,0)"}},[_c('defs',[_c('style',[_v('.a{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}')])]),_c('title',[_v('navigation-menu-3')]),_c('circle',{staticClass:"a",attrs:{"cx":"12","cy":"12.003","r":"11.25"}}),_c('line',{staticClass:"a",attrs:{"x1":"7.5","y1":"8.253","x2":"16.5","y2":"8.253"}}),_c('line',{staticClass:"a",attrs:{"x1":"7.5","y1":"12.003","x2":"16.5","y2":"12.003"}}),_c('line',{staticClass:"a",attrs:{"x1":"7.5","y1":"15.753","x2":"16.5","y2":"15.753"}})])])
          )
        }
      }
    